type ImportFetchOptions = {
  method: string;
  headers: Record<string, string>;
  credentials: RequestCredentials;
  body?: string;
};

export async function executeImportUpsert(options: {
  createPayloads: unknown[];
  updateEntries: Array<{ id: string; payload: unknown }>;
  deleteIds: string[];
  bulkCreateUrl?: string;
  updateUrl: (id: string) => string;
  deleteUrl: (id: string) => string;
  fetchFn?: typeof fetch;
  buildRequest: (init: { method: string; body?: unknown }) => ImportFetchOptions;
}): Promise<boolean> {
  const fetchFn = options.fetchFn ?? fetch;

  if (options.bulkCreateUrl && options.createPayloads.length > 0) {
    const response = await fetchFn(
      options.bulkCreateUrl,
      options.buildRequest({
        method: 'POST',
        body: options.createPayloads,
      }),
    );
    if (!response.ok) {
      return false;
    }
  }

  for (const entry of options.updateEntries) {
    const response = await fetchFn(
      options.updateUrl(entry.id),
      options.buildRequest({
        method: 'PUT',
        body: entry.payload,
      }),
    );
    if (!response.ok) {
      return false;
    }
  }

  for (const id of options.deleteIds) {
    const response = await fetchFn(
      options.deleteUrl(id),
      options.buildRequest({ method: 'DELETE' }),
    );
    if (!response.ok) {
      return false;
    }
  }

  return true;
}
